var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHistoryPrimary(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 3H15.25C15.7141 3 16.1592 3.1873 16.4874 3.5207C16.8156 3.8541 17 4.30628 17 4.77778V17.2222C17 17.6937 16.8156 18.1459 16.4874 18.4793C16.1592 18.8127 15.7141 19 15.25 19H4.75C4.28587 19 3.84075 18.8127 3.51256 18.4793C3.18437 18.1459 3 17.6937 3 17.2222V4.77778C3 4.30628 3.18437 3.8541 3.51256 3.5207C3.84075 3.1873 4.28587 3 4.75 3H6.5",
    fill: "#6A6A99"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 3H15.25C15.7141 3 16.1592 3.1873 16.4874 3.5207C16.8156 3.8541 17 4.30628 17 4.77778V17.2222C17 17.6937 16.8156 18.1459 16.4874 18.4793C16.1592 18.8127 15.7141 19 15.25 19H4.75C4.28587 19 3.84075 18.8127 3.51256 18.4793C3.18437 18.1459 3 17.6937 3 17.2222V4.77778C3 4.30628 3.18437 3.8541 3.51256 3.5207C3.84075 3.1873 4.28587 3 4.75 3H6.5",
    stroke: "#6A6A99",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 8L8.5 13L6 10.7273",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 1H7.75C7.33579 1 7 1.55964 7 2.25V4.75C7 5.44036 7.33579 6 7.75 6H12.25C12.6642 6 13 5.44036 13 4.75V2.25C13 1.55964 12.6642 1 12.25 1Z",
    fill: "#6A6A99",
    stroke: "#6A6A99",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryPrimary);
export default __webpack_public_path__ + "static/media/historyPrimary.dc1989ff8cf56f07f95a8d3f2f085a8d.svg";
export { ForwardRef as ReactComponent };